import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import About from "../containers/About"

type AboutPageProps = {}

const AboutPage: React.FunctionComponent<AboutPageProps> = props => {
  return (
    <Layout>
      <SEO
        title="About"
        description="Sleepy Roo is a resource for parents to help them manage their babies sleep. Turn your child into a sleepy roo!"
      />

      <About />
    </Layout>
  )
}

export default AboutPage
